import { render, staticRenderFns } from "./create-homeWork.vue?vue&type=template&id=cf10f444&scoped=true&"
import script from "./create-homeWork.vue?vue&type=script&lang=ts&"
export * from "./create-homeWork.vue?vue&type=script&lang=ts&"
import style0 from "./create-homeWork.vue?vue&type=style&index=0&id=cf10f444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf10f444",
  null
  
)

export default component.exports